module.exports = "<div>\n  <ng-select [formControl]=\"searchContinueCaseInputControl\" class=\"custom\" placeholder=\"&#xF002; Search Case Id\">\n    <ng-option *ngFor=\"let v of searchContinueCaseResults\" [value]=\"v.caseId\">{{v.caseId}}</ng-option>\n  </ng-select>\n</div>"


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/crm/continue-case-select-box/continue-case-select-box.component.html
// module id = ../../../../../src/app/crm/continue-case-select-box/continue-case-select-box.component.html
// module chunks = main